import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-saveData",
  "use": "icon-saveData-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-saveData\"><path d=\"M512 35.84L99.4816 273.8176v476.16L512 988.16l412.5184-238.1824v-476.16z m325.2736 258.56L512 476.672 191.8464 291.4304 512 106.5984z m-676.352 50.1248L481.28 529.7152v369.92l-320.3584-184.9344zM542.72 899.6352v-369.664l320.3584-179.6096v364.288z\" p-id=\"111676\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol